import Axios from '@/utils/axios'
import { extractOnlyNumbers } from '@/utils/formatter'
import Cookies from 'js-cookie'

export default {
  searchCpf: async cpf => {
    try {
      const cpfUnmasked = extractOnlyNumbers(cpf)

      const { status, data } = await Axios.get(`/cpf/${cpfUnmasked}`)

      return {
        status,
        novoAcesso: data.novoAcesso,
        nome: data.nome,
        email: data.email,
        agendamentoExpress: data.agendamentoExpress,
        idEmpresaFuncionario: data.idEmpresaFuncionario
      }
    } catch (error) {
      return {
        status: error.response.status
      }
    }
  },
  searchUser: async identifier => {
    try {
      // Remove máscara se for CPF
      const cleanIdentifier = identifier.includes('@') ? identifier : extractOnlyNumbers(identifier)

      const { status, data } = await Axios.get(`/user/${cleanIdentifier}`)

      return {
        status,
        novoAcesso: data.novoAcesso,
        nome: data.nome,
        email: data.email,
        agendamentoExpress: data.agendamentoExpress,
        idEmpresaFuncionario: data.idEmpresaFuncionario
      }
    } catch (error) {
      return {
        status: error.response.status
      }
    }
  },
  login: (cpf, senha) => {
    const cpfUnmasked = extractOnlyNumbers(cpf)

    return Axios.post('/login', { cpf: cpfUnmasked, senha })
  },
  loginWithEmail: (email, senha) => {
    return Axios.post('/login', { email, senha })
  },
  logout: () => {
    Cookies.remove('ami_user_token')
  },
  register: ({ cpf, nome, senha }) => {
    const cpfUnmasked = extractOnlyNumbers(cpf)

    return Axios.post('/register', {
      cpf: cpfUnmasked,
      nome,
      senha
    })
  },
  setToken: token => {
    Cookies.set('ami_user_token', token, { expires: 1 })
  },
  isAuthenticated: () => !!Cookies.get('ami_user_token'),
  recuperarSenha: (email, workspaceUrl) => {
    return Axios.post('/recuperar-senha', {}, { params: { email, workspaceUrl } })
  },
  verificaTokenRedefinirSenha: token => {
    return Axios.get('/redefinir-senha', { params: { token } })
  },
  redefinirSenha: ({ senha, token }) => {
    return Axios.post('/redefinir-senha', { senha }, { params: { token } })
  }
}
